import { render, staticRenderFns } from "./PersonBlock.vue?vue&type=template&id=62eef38f&lang=pug&"
import script from "./PersonBlock.vue?vue&type=script&lang=js&"
export * from "./PersonBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports